(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[22],{

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salesmanIDRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return internationalPhoneRegex; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__);




 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
var salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,20}$/);
};

var internationalPhoneRegex = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);


/***/ }),

/***/ "BU6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return WECHAT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ECYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPLIFT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PLEDG_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAYPAL_PSP_ID; });
/* unused harmony export ESSPSCT_PSP_ID */
/* unused harmony export ESSPSDD_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NODELCRERE_TRANSFER_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NODELCRERE_CHEQUE_PSP_ID; });
/* unused harmony export HIPAY_CMTA_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EGLOBALCOLLECT_PSP_ID; });
/* unused harmony export OGONE_CMTA_PSP_ID */
/* unused harmony export OGONE_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PAYMENT_METHOD_LABEL; });
/* unused harmony export BANK_TRANSFER_LABEL */
/* unused harmony export CHEQUE_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREDIT_CARD_LABEL; });
/* unused harmony export PAYPAL_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return VOXPAY_PSP_ID_PREFIX; });
/* unused harmony export VOXPAY_PHONE_PSP_ID */
/* unused harmony export VOXPAY_PHONE_LABEL */
/* unused harmony export VOXPAY_EMAIL_PSP_ID */
/* unused harmony export VOXPAY_EMAIL_LABEL */
/* unused harmony export VOXPAY_SMS_PSP_ID */
/* unused harmony export VOXPAY_SMS_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NAPAY_PSP_ID; });
/* unused harmony export PROVIDER_ID_EVOPAY_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PAYMENT_METHOD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TRACKING_PAYMENT_METHOD_CATEGORY; });
var WECHAT_PSP_ID = 'M99BILLW';
var CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
var ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
var UPLIFT_PSP_ID = 'MUPLIFT';
var PLEDG_PSP_ID = 'MPLEDG';
var HIPAY_PSP_ID = 'MHIPAY';
var PAYPAL_PSP_ID = 'MHIPAYPP';
var ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER

var ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT

var NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER

var NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT

var HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
var EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT

var OGONE_CMTA_PSP_ID = 'MOGONE';
var OGONE_PSP_ID = 'EOGONE';
var PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
var BANK_TRANSFER_LABEL = 'Bank Transfer';
var CHEQUE_LABEL = 'Cheque';
var CREDIT_CARD_LABEL = 'Credit Card';
var PAYPAL_LABEL = 'Paypal';
var VOXPAY_PSP_ID_PREFIX = 'EVOXPAY';
var VOXPAY_PHONE_PSP_ID = 'EVOXPAY_PHONE';
var VOXPAY_PHONE_LABEL = 'Phone';
var VOXPAY_EMAIL_PSP_ID = 'EVOXPAY_EMAIL';
var VOXPAY_EMAIL_LABEL = 'Email';
var VOXPAY_SMS_PSP_ID = 'EVOXPAY_SMS';
var VOXPAY_SMS_LABEL = 'Sms';
var NAPAY_PSP_ID = 'NAPAY';
var PROVIDER_ID_EVOPAY_PREFIX = 'EVOXPAY';
var PAYMENT_METHOD_CATEGORY = {
  BUY_NOW_PAY_LATER: 'BuyNowPayLater',
  CREDIT_CARD: 'CreditCard',
  CARD: 'card',
  PAYPAL: 'Paypal',
  DIRECT_DEBIT: 'DirectDebit',
  BANK_TRANSFER: 'BankTransfer'
};
var TRACKING_PAYMENT_METHOD_CATEGORY = {
  CreditCard: 'Credit Card',
  DirectDebit: 'Direct Debit',
  BankTransfer: 'Bank Transfer'
};

/***/ }),

/***/ "XpIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LEGAL_INFO_WEBTHEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEGAL_INFO_NDC_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LEGAL_INFO_THEO_ID; });
/* unused harmony export LEGAL_INFO_SMS_ID */
/* unused harmony export LEGAL_INFO_EMAIL_ID */
/* unused harmony export LEGAL_INFO_MAIL_ID */
/* unused harmony export LEGAL_INFO_FOSUN_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGAL_INFO_CGV_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEALTH_REGULATION; });
var LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
var LEGAL_INFO_NDC_ID = 'NDC';
var LEGAL_INFO_THEO_ID = 'THEO';
var LEGAL_INFO_SMS_ID = 'SMS_OPTIN';
var LEGAL_INFO_EMAIL_ID = 'EMAIL_OPTIN';
var LEGAL_INFO_MAIL_ID = 'MAIL_OPTIN';
var LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
var LEGAL_INFO_CGV_ID = 'CGV';
var HEALTH_REGULATION = 'HEALTH_REGULATION';

/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getSchemaValidators; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ ContactInfoUtils_getTravelDocumentsValidators; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getLegalAgreementValidator; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ ContactInfoUtils_getSalesmanIdValidator; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ ContactInfoUtils_trackAttendeesFormError; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ ContactInfoUtils_isChildWillBeAdultByArrivalDate; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ ContactInfoUtils_travelCompanionMapper; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createId; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ ContactInfoUtils_filterSearchedChildren; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ findAlphabetIndex; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ setTravelCompanionBlockFormErrors; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getTravelCompanionInfos; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ ContactInfoUtils_setTravelCompanionField; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ ContactInfoUtils_shouldHideField; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ ContactInfoUtils_getHouseholdsAttendees; });

// UNUSED EXPORTS: tripInformationToAttendeesList, getNextCharacter, getChildrenToAdultsTransferList, compareById, compareByBirthdate, getSortedTravelCompanionList, getFieldErrors, getCNILLegalMessage, getLegalInformation, submitOptionFromProposal, getLegalInputInformation, shouldDisplayLegalInformation, getDocumentsFields

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isObject.js
var isObject = __webpack_require__("tQYX");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flatten.js
var flatten = __webpack_require__("1xil");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/option-validity/constants.js
var option_validity_constants = __webpack_require__("l/UU");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js








var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/identityNumberValidator.reducer.js









var identityNumberRule = lib["string"]().matches(/[a-zA-Z0-9]{6,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var fiscalCodeRule = lib["string"]().matches(/[a-zA-Z0-9]{16,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var identityNumberValidator_reducer_identityNumberValidatorReducer = function identityNumberValidatorReducer(locale, attendeeSchema) {
  var _attendeeSchema$find;

  var isIdentityNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref) {
    var name = _ref.name;
    return name === 'identity_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var brazilCpfRule = lib["string"]().test('is-brazil-cpf-rule-valid', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
    var trimValue = value ? value.trim() : '';

    if (!isIdentityNumberRequired) {
      // field isn't required: check cpf validity is has truthy value or return true
      return trimValue ? isValidCPF(value) : true;
    } // field is required: return cpf validity if has truthy value or return false


    var invalidCpfFormat = value.length < 11 || value.length > 14 || !isValidCPF(value);
    return trimValue && !invalidCpfFormat;
  });

  switch (locale) {
    case locale_constants["a" /* LOCALES */].PT_BR:
      return brazilCpfRule;

    case locale_constants["a" /* LOCALES */].IT_IT:
      return fiscalCodeRule;

    default:
      return identityNumberRule;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js









































function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





















 // removing mergeSchemas method cause it does not have expected behavior.
// https://github.com/jquense/yup#schemaconcatschema-schema-schema -> doc explaning that is does not merge content but override previous schema.
// https://github.com/jquense/yup/issues/1535 -> issue explaining that it does not merge content but override previous schema.
// Using yup.addMethods that allows us to add custom methods to Yup when needed so it's possible to chain schemas in prefered order.

function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === contact_info_constants["b" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && pick_default()(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id && (type && legalMessage.type ? legalMessage.type === type : true);
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["c" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["k" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["g" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["d" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["i" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(constants["d" /* LEGAL_INFO_THEO_ID */]),
    webTheo: getLegalInfo(constants["e" /* LEGAL_INFO_WEBTHEO_ID */]),
    ndc: getLegalInfo(constants["c" /* LEGAL_INFO_NDC_ID */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        ").concat(hasSaveOption || isChequeOrTransferPaymentLabel ? 'bookingStatus: OPTION' : 'bookingStatus: PENDING_PAYMENT', "\n        ").concat(params.sellerEmail ? "sellerEmail: \"".concat(params.sellerEmail, "\"") : '', "\n        ").concat(salesmanID ? "salesmanID: \"".concat(salesmanID, "\"") : '', "\n      ) {\n        bookingId\n        expirationDateTime\n        isReliable\n      }\n    }");
}

function submitOptionFromProposal(_ref) {
  var appContext = _ref.appContext,
      sellerEmail = _ref.sellerEmail,
      selectedProposalId = _ref.selectedProposalId,
      productId = _ref.productId,
      hasSaveOption = _ref.hasSaveOption,
      salesmanID = _ref.salesmanID,
      hasNoRedirection = _ref.hasNoRedirection,
      withfutureTravelCredits = _ref.withfutureTravelCredits,
      router = _ref.router;
  return function (proposal) {
    var redirectTo = redirectUtils["a" /* default */].redirectToUri(router);
    var params = {
      proposalId: (proposal === null || proposal === void 0 ? void 0 : proposal.id) || '',
      sellerEmail: sellerEmail
    };
    var paymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["j" /* PAYMENT_METHOD_LABEL */]);
    var isChequeOrTransferPaymentLabel = paymentMethodLabel === PaymentInfo_const["i" /* PAYMENT_METHOD_CATEGORY */].DIRECT_DEBIT || paymentMethodLabel === PaymentInfo_const["i" /* PAYMENT_METHOD_CATEGORY */].BANK_TRANSFER; // hide by default the salesmanID warning message if we have a not empty salesmanID

    if (appContext.isSeller) {
      js_cookie_default.a.set("".concat(contact_info_constants["h" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), salesmanID === '' ? 'show' : 'hide', {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
    }

    var queryWithSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID);

    var queryWithoutSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel);

    var handleSuccess = function handleSuccess(response) {
      var _response$bookings, _response$bookings2, _response$bookings3;

      var queryParams = _objectSpread({
        bi: (response === null || response === void 0 ? void 0 : (_response$bookings = response.bookings) === null || _response$bookings === void 0 ? void 0 : _response$bookings.bookingId) || '',
        expirationTime: (response === null || response === void 0 ? void 0 : (_response$bookings2 = response.bookings) === null || _response$bookings2 === void 0 ? void 0 : _response$bookings2.expirationDateTime) || '',
        isReliable: response === null || response === void 0 ? void 0 : (_response$bookings3 = response.bookings) === null || _response$bookings3 === void 0 ? void 0 : _response$bookings3.isReliable,
        selectedProposalId: selectedProposalId,
        productId: productId
      }, hasSaveOption && {
        hasSaveOption: hasSaveOption
      });

      if (withfutureTravelCredits) {
        queryParams.futureTravelCreditOption = true;
      }

      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, queryParams))();
    };

    var handleError = function handleError(error) {
      var status = get_default()(error, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);

      var errorCode = get_default()(error, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');

      var errorDescription = get_default()(error, 'errors[0].responseBody.errors[0].error_description');

      if (status === statusCode_constants["b" /* STATUS_CODE_400 */] && errorCode === contact_info_constants["k" /* WRONG_SALESMAN_ID */]) {
        // hide the salesmanID warning message if we have a wrong salesmanId on the confirmation page
        js_cookie_default.a.set("".concat(contact_info_constants["h" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), 'show', {
          secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
        });
        return graphqlClient["a" /* default */].runNoCacheQuery(queryWithoutSalesmanID, appContext, {
          requestName: requestDictionary["od" /* PROPOSAL_UPDATE */]
        }).then(handleSuccess)["catch"](handleError);
      }

      var isBookingInSameTimeOfProposalError = !appContext.isSeller && hasSaveOption && errorCode === option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */];
      !hasNoRedirection && !isBookingInSameTimeOfProposalError && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
        status: status,
        error_code: errorCode,
        error_description: errorDescription
      }, {
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
      return {
        isRedirectionPerfomed: false,
        reason: isBookingInSameTimeOfProposalError ? option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */] : null
      };
    };

    return graphqlClient["a" /* default */].runNoCacheQuery(queryWithSalesmanID, appContext, {
      requestName: requestDictionary["od" /* PROPOSAL_UPDATE */]
    }).then(handleSuccess)["catch"](handleError);
  };
}

function submitOption(appContext, router, sellerEmail, hasSaveOption, salesmanID, withfutureTravelCredits) {
  var _router$query = router.query,
      selectedProposalId = _router$query.selectedProposalId,
      productId = _router$query.product;
  return submitOptionFromProposal({
    appContext: appContext,
    sellerEmail: sellerEmail,
    selectedProposalId: selectedProposalId,
    productId: productId,
    hasSaveOption: hasSaveOption,
    salesmanID: salesmanID,
    router: router,
    withfutureTravelCredits: withfutureTravelCredits
  });
}

function renderErrorUpdatingAttendees(_ref2) {
  var errors = _ref2.errors,
      statusCode = _ref2.statusCode;

  if (statusCode && (statusCode === statusCode_constants["f" /* STATUS_CODE_500 */] || statusCode === statusCode_constants["c" /* STATUS_CODE_401 */])) {
    return Object(i18n["h" /* t */])('booking.form.errors.technicalErrorParticipants');
  }

  if (errors === null || errors === void 0 ? void 0 : errors.length) {
    var _errors$;

    var errorCode = errors === null || errors === void 0 ? void 0 : (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.errorCode;
    var cmsErrorKey = "booking.participants.errorMessage.".concat(errorCode);

    if (errorCode && cmsErrorKey !== Object(i18n["h" /* t */])(cmsErrorKey)) {
      return Object(i18n["h" /* t */])(cmsErrorKey);
    }
  }

  return Object(i18n["h" /* t */])('booking.form.errorLabel');
}

var getAttendeeId = function getAttendeeId(_ref3) {
  var neolid = _ref3.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref4) {
  var adults = _ref4.adults,
      kids = _ref4.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids && kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref5) {
  var bookingProcess = _ref5.bookingProcess,
      adultCivilityDefaultValue = _ref5.adultCivilityDefaultValue,
      childCivilityDeefaultValue = _ref5.childCivilityDeefaultValue,
      households = _ref5.households,
      connectedUserInfo = _ref5.connectedUserInfo,
      hasAddress = _ref5.hasAddress,
      locale = _ref5.locale,
      getAttendeeSchema = _ref5.getAttendeeSchema,
      displayParticipantsSelectInput = _ref5.displayParticipantsSelectInput,
      _ref5$preCheckedOptin = _ref5.preCheckedOptins,
      preCheckedOptins = _ref5$preCheckedOptin === void 0 ? {} : _ref5$preCheckedOptin;
  var optins = ContactInfoUtils_getOptinsInfos(bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    var _preCheckedOptins$opt;

    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return Boolean((_preCheckedOptins$opt = preCheckedOptins[optinName]) !== null && _preCheckedOptins$opt !== void 0 ? _preCheckedOptins$opt : optin.preChecked);
  };

  var defaultCountryCode = locale.split('-')[1];

  var getDocumentInfo = function getDocumentInfo(documents, documentType, type, attendeeSchema) {
    var document = documents === null || documents === void 0 ? void 0 : documents[documentType];

    var getFieldDefaultValue = function getFieldDefaultValue(value, field) {
      var defaultValue = {}; // should only initialize these values if they exist in the schema V1

      if (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(field);
      })) {
        defaultValue[field] = value || defaultCountryCode;
      }

      return defaultValue;
    };

    var getFieldDefaulDate = function getFieldDefaulDate(value, field) {
      if (value && (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(field);
      }))) {
        return Object(apiDate["d" /* apiDateToTimestamp */])(value);
      }

      return value;
    };

    var issuingDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.issuingDate, 'issuing_date');
    var expirationDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.expirationDate, 'expiration_date');

    var formattedDocument = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, document || {}), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.nationality, 'nationality')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.issuingCountry, 'issuingCountry')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.birthCountry, 'birthCountry')), issuingDate ? {
      issuingDate: issuingDate
    } : {}), expirationDate ? {
      expirationDate: expirationDate
    } : {}); // type is to be sent in Put Attendees should be in [PASSPORT, IDCARD]


    return isEmpty_default()(formattedDocument) ? undefined : _objectSpread(_objectSpread({}, formattedDocument), {}, {
      type: type
    });
  };

  var kidCivilities = Object(domains_service_dist["getKidsCivilities"])(locale);

  var getBirthday = function getBirthday(birthdate) {
    return birthdate && typeof birthdate === 'number' ? birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(birthdate);
  };

  return households.map(function (_ref6) {
    var adults = _ref6.adults,
        children = _ref6.children;
    return {
      adults: adults.map(function (adult, index) {
        var _adult$address;

        return _objectSpread(_objectSpread(_objectSpread({}, adult), {}, {
          attendeeIndex: index,
          civility: displayParticipantsSelectInput ? '' : adult.civility || adultCivilityDefaultValue,
          document: {
            passport: getDocumentInfo(adult.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(!!adult.isMain, false)),
            idcard: getDocumentInfo(adult.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(!!adult.isMain, false))
          },
          birthdate: adult.birthdate && getBirthday(adult.birthdate),
          address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, adult.address), {}, {
            countryCode: ((_adult$address = adult.address) === null || _adult$address === void 0 ? void 0 : _adult$address.countryCode) || defaultCountryCode
          }) : undefined
        }, adult.isMain ? {
          optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
          optinSms: getOptinValue(optins.sms, 'optinSms', adult),
          optinMail: getOptinValue(optins.mail, 'optinMail', adult),
          optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
          optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
          optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
          legalAgreement: false,
          checkAll: false
        } : null), {}, {
          mainContactId: !adult.gmNumber && adults[0].neolid ? adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

        });
      }),
      children: children.map(function (child, index) {
        var _kidCivilities$, _adults$, _adults$2;

        return _objectSpread(_objectSpread({}, child || {}), {}, {
          attendeeIndex: index,
          civility: (child === null || child === void 0 ? void 0 : child.civility) || childCivilityDeefaultValue || ((_kidCivilities$ = kidCivilities[0]) === null || _kidCivilities$ === void 0 ? void 0 : _kidCivilities$.value),
          document: {
            passport: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(false, true)),
            idcard: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(false, true))
          },
          birthdate: child.birthdate && getBirthday(child.birthdate),
          mainContactId: !(child === null || child === void 0 ? void 0 : child.gmNumber) && ((_adults$ = adults[0]) === null || _adults$ === void 0 ? void 0 : _adults$.neolid) ? (_adults$2 = adults[0]) === null || _adults$2 === void 0 ? void 0 : _adults$2.neolid : '0'
        });
      })
    };
  });
};
function getSchemaValidators(schema) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref7$withRequired = _ref7.withRequired,
      withRequired = _ref7$withRequired === void 0 ? true : _ref7$withRequired,
      _ref7$requiredMessage = _ref7.requiredMessage,
      requiredMessage = _ref7$requiredMessage === void 0 ? function (fieldValidation) {
    return Object(i18n["h" /* t */])("booking.participants.errorMessage.".concat(camelCase_default()(fieldValidation.name)));
  } : _ref7$requiredMessage,
      _ref7$messages = _ref7.messages,
      messages = _ref7$messages === void 0 ? {} : _ref7$messages,
      _ref7$isDateType = _ref7.isDateType,
      isDateType = _ref7$isDateType === void 0 ? false : _ref7$isDateType,
      _ref7$isNullable = _ref7.isNullable,
      isNullable = _ref7$isNullable === void 0 ? false : _ref7$isNullable;

  return schema === null || schema === void 0 ? void 0 : schema.reduce(function (addressValidators, fieldValidation) {
    var rule = isDateType ? lib["date"]() : lib["string"]();

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required(requiredMessage(fieldValidation));
      }
    }

    fieldValidation.validators.forEach(function (validator) {
      var _messages$fieldValida;

      var message = messages === null || messages === void 0 ? void 0 : (_messages$fieldValida = messages[fieldValidation.name]) === null || _messages$fieldValida === void 0 ? void 0 : _messages$fieldValida[validator.name];

      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(new RegExp(validator.value), message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooShort', {
            minlength: validator.value
          }));
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooLong', {
            maxlength: validator.value
          }));
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });
    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, isNullable ? rule.nullable() : rule));
  }, {});
}

var getDateSchemaByName = function getDateSchemaByName(attendeeSchema, validatorName) {
  return getSchemaValidators(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.filter(function (_ref8) {
    var name = _ref8.name;
    return name === validatorName;
  }), {
    isDateType: true
  }) || {};
};

var korean = /(\S*[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+\S*)/;
var japanese = /(\S*[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤ヶ]+\S*)/;
var hebrew = /^[\u0590-\u05fe]+$/;
var cyrillic = /(\S*[u0400-\u04FF]+$)/;
var chinese = /(\S*[\u4e00-\u9fff]+$)/;
var thai = /(\S*[\u0E01-\u0E5B]+|[\u1980-\u19DF]+|[\u1950-\u197F]+|[\u1A20-\u1AAF]+|[\uAA80-\uAADF]+$)/;
var asciiWordRegex = /^[\x20-\xFF]+$/; // ASCII

var getNonAsciiNameValidatorByLocale = function getNonAsciiNameValidatorByLocale(locale) {
  switch (locale) {
    case 'ko-KR':
      return korean;

    case 'zh-CN':
    case 'zh-HK':
    case 'zh-TW':
      return chinese;

    case 'ja-JP':
      return japanese;

    case 'ru-RU':
    case 'uk-UA':
    case 'sr-RS':
      return cyrillic;

    case 'he-IL':
      return hebrew;

    case 'th-TH':
      return thai;

    default:
      return asciiWordRegex;
  }
};

var ContactInfoUtils_getValidators = function getValidators(_ref9) {
  var attendeeSchema = _ref9.attendeeSchema,
      addressSchema = _ref9.addressSchema,
      locale = _ref9.locale,
      arrivalDate = _ref9.arrivalDate,
      adultCivilities = _ref9.adultCivilities,
      childCivilities = _ref9.childCivilities; // Validators coming from API, to be merged with local validators

  var addressSchemaValidators = getSchemaValidators(addressSchema, {
    isNullable: true
  }) || {};
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var birthdateValidator = getDateSchemaByName(attendeeSchema, 'birthdate');
  lib["addMethod"](lib["string"], 'asciiNameValidator', function () {
    return this.matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  lib["addMethod"](lib["string"], 'unicodeNameValidator', function () {
    return this.matches(getNonAsciiNameValidatorByLocale(locale), Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')),
    childCivilities: lib["string"]().oneOf(childCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')),
    firstName: (attendeeSchemaValidators.first_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(20).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.firstName')),
    lastName: (attendeeSchemaValidators.last_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(30).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.lastName')),
    unicodeFirstName: (attendeeSchemaValidators.unicode_first_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeFirstName')),
    unicodeLastName: (attendeeSchemaValidators.unicode_last_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeLastName')),
    adultBirthDate: (birthdateValidator.birthdate || lib["date"]()).transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(contact_info_constants["l" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["d" /* MAX_AGE */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(contact_info_constants["l" /* YEAR_OF_MAJORITY */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    email: (attendeeSchemaValidators.email || lib["string"]()).matches(RegexHelper["a" /* emailRegex */], Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.email')),
    mobile: lib["string"]().matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.mobilePhone')),
    healthPassId: (attendeeSchemaValidators.health_pass_id || lib["string"]()).length(10),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')),
    gmNumber: (attendeeSchemaValidators.gm_number || lib["string"]()).required()
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: addressSchemaValidators
  });
};
var ContactInfoUtils_getTravelDocumentsValidators = function getTravelDocumentsValidators(_ref10) {
  var _attendeeSchema$find;

  var attendeeSchema = _ref10.attendeeSchema,
      locale = _ref10.locale,
      departureDate = _ref10.departureDate,
      arrivalDate = _ref10.arrivalDate; // Validators coming from API, to be merged with local validators

  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var idcardExpDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_expiration_date');
  var idcardIssuingDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_issue_date');
  var passportExpDateValidator = getDateSchemaByName(attendeeSchema, 'passport_expiration_date');
  var passportIssDateValidator = getDateSchemaByName(attendeeSchema, 'passport_issue_date');
  var isDocumentNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref11) {
    var name = _ref11.name;
    return name === 'passport_document_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var identityNumberGeneralRule = identityNumberValidator_reducer_identityNumberValidatorReducer(locale, attendeeSchema);
  lib["addMethod"](lib["string"], 'documentNumberRule', function () {
    return this.test('is-passport-required', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
      var trimmedDocNumber = value === null || value === void 0 ? void 0 : value.trim();

      if (trimmedDocNumber) {
        // typed somthing apart from white spaces
        var isValidDocNumber = Boolean(trimmedDocNumber === null || trimmedDocNumber === void 0 ? void 0 : trimmedDocNumber.match(/[a-zA-Z0-9]{6,}$/));
        return isValidDocNumber;
      }

      return !isDocumentNumberRequired;
    }).max(30);
  });
  lib["addMethod"](lib["date"], 'expirationDateRule', function () {
    return this.transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).min(moment_default()(departureDate).add(1, 'd'));
  });
  lib["addMethod"](lib["date"], 'issuingDateRule', function () {
    return this.transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(1, 'd'));
  });
  var rawValidators = {
    idcardDocumentNumber: (attendeeSchemaValidators.idcard_document_number || lib["string"]()).nullable().documentNumberRule(),
    passportDocumentNumber: (attendeeSchemaValidators.passport_document_number || lib["string"]()).nullable().documentNumberRule(),
    idcardExpirationDate: (idcardExpDateValidator.idcard_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    passportExpirationDate: (passportExpDateValidator.passport_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    idcardIssueDate: (idcardIssuingDateValidator.idcard_issue_date || lib["date"]()).nullable().issuingDateRule(),
    passportIssueDate: (passportIssDateValidator.passport_issue_date || lib["date"]()).nullable().issuingDateRule(),
    idcardNationality: (attendeeSchemaValidators.idcard_nationality || lib["string"]()).nullable(),
    passportNationality: (attendeeSchemaValidators.passport_nationality || lib["string"]()).nullable(),
    idcardAuthority: (attendeeSchemaValidators.idcard_authority || lib["string"]()).nullable(),
    passportAuthority: (attendeeSchemaValidators.passport_authority || lib["string"]()).nullable(),
    idcardBirthCountry: (attendeeSchemaValidators.idcard_birth_country || lib["string"]()).nullable(),
    passportBirthCountry: attendeeSchemaValidators.passport_birth_country || lib["string"](),
    identityNumber: attendeeSchemaValidators.identity_number || identityNumberGeneralRule
  }; // $FlowFixMe

  return rawValidators;
};
var ContactInfoUtils_getLegalAgreementValidator = function getLegalAgreementValidator() {
  return lib["mixed"]().oneOf([true]).required();
};
var ContactInfoUtils_getSalesmanIdValidator = function getSalesmanIdValidator(_ref12) {
  var attendeeSchema = _ref12.attendeeSchema;
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema);
  return ((attendeeSchemaValidators === null || attendeeSchemaValidators === void 0 ? void 0 : attendeeSchemaValidators.salesman_id) || lib["string"]()).matches(RegexHelper["e" /* salesmanIDRegex */]);
};

function getDocumentsFields(bookingProcess) {
  return legalInformationIds_constants["b" /* DOCUMENT_TYPES */].reduce(function (fields, type) {
    var filteredFields = {
      type: type.toLowerCase(),
      values: bookingProcess.filter(function (field) {
        return field.type === type;
      })
    }; // returns all fields in bookingProcess or TransportBookingProcess with the current type(s)

    filteredFields.values.length > 0 && fields.push(filteredFields);
    return fields;
  }, []);
}

var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultCivilities = Object(domains_service_dist["getAdultsCivilities"])(locale);
  return isEmpty_default()(adultCivilities) ? defaultCivilities : adultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref13) {
  var isMain = _ref13.isMain,
      isChild = _ref13.isChild,
      hasUnicodeFields = _ref13.hasUnicodeFields,
      formValues = _ref13.formValues,
      attendeeIdentifier = _ref13.attendeeIdentifier,
      attendeeIndex = _ref13.attendeeIndex,
      isValid = _ref13.isValid;

  if (hasUnicodeFields && isValid) {
    return "".concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
  }

  var firstName = get_default()(formValues, "".concat(attendeeIdentifier, ".firstName"));

  var lastName = get_default()(formValues, "".concat(attendeeIdentifier, ".lastName"));

  if (!!firstName && !!lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }

  if (isMain) {
    return Object(i18n["h" /* t */])('booking.participants.personnalInfosHeader.title');
  }

  if (isChild) {
    return "".concat(Object(i18n["h" /* t */])('booking.participants.otherKidsInfosHeader.title'), " ").concat(attendeeIndex + 1);
  }

  return "".concat(Object(i18n["h" /* t */])('booking.participants.otherAdultsInfosHeader.title'), " ").concat(attendeeIndex);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref14) {
  var connectedUserInfo = _ref14.connectedUserInfo,
      userIsSeller = _ref14.userIsSeller,
      formInitialValues = _ref14.formInitialValues,
      fieldName = _ref14.fieldName,
      attendeeIdentifier = _ref14.attendeeIdentifier,
      fieldNameConnectedUserOverride = _ref14.fieldNameConnectedUserOverride;

  if (connectedUserInfo && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName])) {
    return true;
  } // if the attendee has a gmNumber he is identified and if he has a value for the field
  // we don't want to permit the seller to modified the field #11741


  return !!(userIsSeller && !!get_default()(formInitialValues, "".concat(attendeeIdentifier, ".neolid")) && !!get_default()(formInitialValues, "".concat(attendeeIdentifier, ".").concat(fieldName)));
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var _Object$keys;

  var duplicates = attendees === null || attendees === void 0 ? void 0 : attendees.reduce(function (acc, attendee, index) {
    if (attendee) {
      var birthdate = attendee.birthdate,
          lastName = attendee.lastName,
          firstName = attendee.firstName;

      if (birthdate && lastName && firstName) {
        var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

        if (acc[key]) {
          acc[key].push(index);
        } else {
          acc[key] = [index];
        }
      }
    }

    return acc;
  }, {});
  (_Object$keys = Object.keys(duplicates)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (key) {
    var _duplicates$key;

    if ((duplicates === null || duplicates === void 0 ? void 0 : (_duplicates$key = duplicates[key]) === null || _duplicates$key === void 0 ? void 0 : _duplicates$key.length) < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return flatten_default()(Object.values(duplicates));
};
var ContactInfoUtils_trackAttendeesFormError = function trackAttendeesFormError(track, formik) {
  var duplicatedAttendeeFieldsInError = ['firstName', 'lastName', 'birthdate'];
  var hasDuplicatedAttendeesErrorAlreadyBeenTracked = false;
  var formErrors = (formik.errors ? Object.values(formik.errors) : []).reduce(function (errors, household) {
    return [].concat(Object(toConsumableArray["a" /* default */])(errors), Object(toConsumableArray["a" /* default */])((household === null || household === void 0 ? void 0 : household.adults) || []), Object(toConsumableArray["a" /* default */])((household === null || household === void 0 ? void 0 : household.children) || []));
  }, []);
  formErrors.forEach(function (error) {
    if (!error) {
      // formik.errors.adults and formik.errors.children (when they are present) are the same size
      // as formik.values.adults and formik.values.children with undefined at that index if there
      // is no error for this attendee
      return;
    }

    var errorEntries = Object.entries(error);
    errorEntries.forEach(function (_ref15) {
      var _ref16 = Object(slicedToArray["a" /* default */])(_ref15, 2),
          field = _ref16[0],
          errorValue = _ref16[1]; // when there is a duplicated attendees error,
      // firstName, lastName and birthdate are set in error whose value is true
      // when the field is in error for an other reason, the error value is an error message


      var isDuplicatedAttendeeError = duplicatedAttendeeFieldsInError.includes(field) && errorValue === true;

      if (isDuplicatedAttendeeError && !hasDuplicatedAttendeesErrorAlreadyBeenTracked) {
        hasDuplicatedAttendeesErrorAlreadyBeenTracked = true;
        track(_objectSpread(_objectSpread({}, booking_constants["d" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
          actionGA: 'participant',
          labelGA: 'error_sameAttendees'
        }));
      }

      if (!isDuplicatedAttendeeError) {
        if (isObject_default()(errorValue)) {
          var nestedFieldsInError = Object.keys(errorValue);
          nestedFieldsInError.forEach(function (nestedField) {
            track(_objectSpread(_objectSpread({}, booking_constants["d" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
              actionGA: 'participant',
              labelGA: "error_fieldError_".concat(nestedField)
            }));
          });
        } else {
          track(_objectSpread(_objectSpread({}, booking_constants["d" /* BE_GA_DEFAULT_PAYLOAD */]), {}, {
            actionGA: 'participant',
            labelGA: "error_fieldError_".concat(field)
          }));
        }
      }
    });
  });
};

var ContactInfoUtils_parseBirthdate = function parseBirthdate(birthdate) {
  if (typeof birthdate === 'string') {
    return moment_default()(birthdate).valueOf();
  }

  return birthdate;
};

var ContactInfoUtils_isChildWillBeAdultByArrivalDate = function isChildWillBeAdultByArrivalDate(childBirthdate, arrivalDate) {
  var childBirthdateValue = ContactInfoUtils_parseBirthdate(childBirthdate);
  var childAge = moment_default()().diff(childBirthdateValue, 'years');
  var childAgeByArrivalDate = moment_default()(arrivalDate).diff(childBirthdateValue, 'years');
  return childAge < 18 && childAgeByArrivalDate >= 18;
};
var ContactInfoUtils_tripInformationToAttendeesList = function tripInformationToAttendeesList(tripInformation) {
  var _tripInformation$kids;

  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(tripInformation.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      isMain: index === 0
    });
  })), Object(toConsumableArray["a" /* default */])(((_tripInformation$kids = tripInformation.kids) === null || _tripInformation$kids === void 0 ? void 0 : _tripInformation$kids.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      isChild: true
    });
  })) || []));
  return {
    adults: attendeesList.filter(function (_ref17) {
      var isChild = _ref17.isChild;
      return !isChild;
    }),
    children: attendeesList.filter(function (_ref18) {
      var isChild = _ref18.isChild;
      return isChild;
    }),
    all: attendeesList.map(function (attendee, index) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        attendeeIndex: Number(index)
      });
    })
  };
};
var ContactInfoUtils_travelCompanionMapper = function travelCompanionMapper(_ref19) {
  var companionId = _ref19.companionId,
      civility = _ref19.civility,
      firstName = _ref19.firstName,
      lastName = _ref19.lastName,
      birthdate = _ref19.birthdate,
      document = _ref19.document,
      mobile = _ref19.mobile,
      email = _ref19.email,
      customerId = _ref19.customerId,
      mainContactId = _ref19.mainContactId,
      isSelected = _ref19.isSelected,
      isChild = _ref19.isChild,
      unicodeFirstName = _ref19.unicodeFirstName,
      unicodeLastName = _ref19.unicodeLastName;
  return _objectSpread(_objectSpread({
    companionId: companionId,
    civility: civility,
    firstName: firstName,
    lastName: lastName,
    document: document,
    mobile: mobile,
    email: email,
    customerId: customerId,
    mainContactId: mainContactId,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName,
    isSelected: isSelected || false
  }, (isChild || dist["attendees"].isKid({
    birthdate: birthdate
  })) && {
    isChild: true
  }), birthdate && {
    birthdate: ContactInfoUtils_parseBirthdate(birthdate)
  });
};
var getNextCharacter = function getNextCharacter(_char) {
  return String.fromCharCode(_char.charCodeAt(0) + 1);
};
var createId = function createId(index, _char2) {
  return String.fromCharCode(_char2.charCodeAt(0) + index);
};
var ContactInfoUtils_getChildrenToAdultsTransferList = function getChildrenToAdultsTransferList(attendeesList, arrivalDate) {
  var adults = attendeesList.adults,
      children = attendeesList.children;

  var toBeAdultFilter = function toBeAdultFilter(_ref20) {
    var birthdate = _ref20.birthdate;
    return birthdate && ContactInfoUtils_isChildWillBeAdultByArrivalDate(birthdate, arrivalDate);
  };

  var indexMap = function indexMap(attendee, index) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      attendeeIndex: Number(index)
    });
  };

  var adultMapper = function adultMapper(_ref21) {
    var civility = _ref21.civility,
        firstName = _ref21.firstName,
        lastName = _ref21.lastName,
        birthdate = _ref21.birthdate,
        neolid = _ref21.neolid,
        gmNumber = _ref21.gmNumber;
    return {
      civility: civility,
      firstName: firstName,
      lastName: lastName,
      birthdate: birthdate,
      neolid: neolid,
      gmNumber: gmNumber,
      isMain: false
    };
  };

  var adultsList = [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children.filter(toBeAdultFilter).map(adultMapper))).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, 'A')
    });
  });
  var nextId = getNextCharacter(adultsList[adultsList.length - 1].id);
  var childrenList = children.filter(function (child) {
    return !children.filter(toBeAdultFilter).includes(child);
  }).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, nextId)
    });
  });
  return {
    adultsList: adultsList,
    childrenList: childrenList,
    allList: [].concat(Object(toConsumableArray["a" /* default */])(adultsList.map(indexMap)), Object(toConsumableArray["a" /* default */])(childrenList.map(indexMap)))
  };
};
var compareById = function compareById(a, b) {
  return a.id.localeCompare(b.id);
};
var ContactInfoUtils_compareByBirthdate = function compareByBirthdate(a, b) {
  return moment_default()(a.birthdate).valueOf() - moment_default()(b.birthdate).valueOf();
};
var ContactInfoUtils_getSortedTravelCompanionList = function getSortedTravelCompanionList() {
  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var travelCompanionListWithoutBirthdate = travelCompanionList.filter(function (_ref22) {
    var birthdate = _ref22.birthdate;
    return !birthdate;
  }).map(function (_ref23) {
    var birthdate = _ref23.birthdate,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref23, ["birthdate"]);

    return _objectSpread({}, rest);
  });
  var sortedTravelCompanionList = travelCompanionList.filter(function (_ref24) {
    var birthdate = _ref24.birthdate;
    return birthdate;
  }).sort(ContactInfoUtils_compareByBirthdate);
  return [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionListWithoutBirthdate), Object(toConsumableArray["a" /* default */])(sortedTravelCompanionList)).filter(function (_ref25) {
    var isMain = _ref25.isMain;
    return !isMain;
  }).map(function (travelCompanion, index) {
    return _objectSpread(_objectSpread({}, travelCompanion), {}, {
      companionId: index
    });
  }).map(ContactInfoUtils_travelCompanionMapper);
};
var ContactInfoUtils_filterSearchedChildren = function filterSearchedChildren() {
  var _uniqBy2, _allAttendees$adults;

  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allAttendees = arguments.length > 1 ? arguments[1] : undefined;
  var sortedCompanionsList = ContactInfoUtils_getSortedTravelCompanionList(travelCompanionList);
  var travelCompanionAdultList = sortedCompanionsList.filter(function (_ref26) {
    var isChild = _ref26.isChild;
    return !isChild;
  });
  var travelCompanionChildrenList = sortedCompanionsList.filter(function (_ref27) {
    var isChild = _ref27.isChild;
    return isChild;
  });
  var formattedCompanionChildrenList = (_uniqBy2 = uniqBy_default()(travelCompanionChildrenList, 'birthdate')) === null || _uniqBy2 === void 0 ? void 0 : _uniqBy2.map(function (child) {
    var _allAttendees$childre;

    var childIndexInForm = allAttendees === null || allAttendees === void 0 ? void 0 : (_allAttendees$childre = allAttendees.children) === null || _allAttendees$childre === void 0 ? void 0 : _allAttendees$childre.findIndex(function (companionChild) {
      return moment_default()(child.birthdate).isSame(companionChild.birthdate);
    });
    var childExistsInForm = childIndexInForm !== -1;
    return _objectSpread(_objectSpread({}, childExistsInForm ? _objectSpread(_objectSpread({}, child), {}, {
      isSelected: true
    }) : child), {}, {
      birthdate: child.birthdate,
      isChild: true,
      isMain: false
    });
  });
  var selectedCompanionChildrenList = formattedCompanionChildrenList.filter(function (_ref28) {
    var isSelected = _ref28.isSelected;
    return isSelected;
  });
  var firstChildIndex = allAttendees === null || allAttendees === void 0 ? void 0 : (_allAttendees$adults = allAttendees.adults) === null || _allAttendees$adults === void 0 ? void 0 : _allAttendees$adults.length;
  var selectedChildrenIndexes = selectedCompanionChildrenList.map(function (_, i) {
    return {
      index: firstChildIndex + i,
      position: i
    };
  });
  var finalCompanionsList = [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionAdultList), Object(toConsumableArray["a" /* default */])(selectedCompanionChildrenList));
  return {
    travelCompanions: finalCompanionsList,
    selectedIndexes: selectedChildrenIndexes
  };
};
var getFieldErrors = function getFieldErrors(_ref29) {
  var _errors$children, _errors$adults;

  var errors = _ref29.errors,
      index = _ref29.index,
      isChild = _ref29.isChild;
  return isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children = errors.children) === null || _errors$children === void 0 ? void 0 : _errors$children[index] : errors === null || errors === void 0 ? void 0 : (_errors$adults = errors.adults) === null || _errors$adults === void 0 ? void 0 : _errors$adults[index];
};

var isLetter = function isLetter(_char3) {
  return !!((_char3 === null || _char3 === void 0 ? void 0 : _char3.length) === 1 && (_char3 === null || _char3 === void 0 ? void 0 : _char3.match(/[a-z]/i)));
};

var findAlphabetIndex = function findAlphabetIndex(_char4) {
  var base = 'a'.charCodeAt(0);
  return isLetter(_char4) ? _char4.toLowerCase().charCodeAt(0) - base : 0;
};
var setTravelCompanionBlockFormErrors = function setTravelCompanionBlockFormErrors(_ref30) {
  var _errors$children2, _errors$adults2;

  var errors = _ref30.errors,
      isChild = _ref30.isChild,
      travelCompanionIndex = _ref30.travelCompanionIndex,
      setFieldTouched = _ref30.setFieldTouched;
  var fieldErrors = isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children2 = errors.children) === null || _errors$children2 === void 0 ? void 0 : _errors$children2[travelCompanionIndex] : errors === null || errors === void 0 ? void 0 : (_errors$adults2 = errors.adults) === null || _errors$adults2 === void 0 ? void 0 : _errors$adults2[travelCompanionIndex];
  var fieldErrorNames = fieldErrors ? Object.keys(fieldErrors) : [];
  fieldErrorNames.forEach(function (fieldErrorName) {
    setFieldTouched("".concat(isChild ? 'children' : 'adults', "[").concat(travelCompanionIndex, "].").concat(fieldErrorName), true);
  });
};
var getTravelCompanionInfos = function getTravelCompanionInfos(_ref31) {
  var travelCompanionSelector = _ref31.travelCompanionSelector,
      isChild = _ref31.isChild,
      parentIndex = _ref31.parentIndex;
  var travelCompanionAdultList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return !travelCompanion.isChild;
  }); // $FlowFixMe

  var travelCompanionChildrenList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return travelCompanion.isChild;
  });
  var travelCompanionList = isChild ? travelCompanionChildrenList : travelCompanionAdultList;
  var hasSelectedTravelCompanion = !!travelCompanionList.find(function (_ref32) {
    var isSelected = _ref32.isSelected;
    return isSelected;
  });
  var hasParentIndexInSelectedIndexes = travelCompanionSelector.selectedIndexes.some(function (indexes) {
    return indexes.index === parentIndex;
  });
  return {
    travelCompanionList: travelCompanionList,
    hasParentIndexInSelectedIndexes: hasParentIndexInSelectedIndexes,
    isDisabled: hasSelectedTravelCompanion && hasParentIndexInSelectedIndexes
  };
};
var ContactInfoUtils_setTravelCompanionField = function setTravelCompanionField(_ref33) {
  var travelCompanion = _ref33.travelCompanion,
      isChild = _ref33.isChild,
      parentIndex = _ref33.parentIndex,
      values = _ref33.values,
      setFieldValue = _ref33.setFieldValue,
      attendeeIdentifier = _ref33.attendeeIdentifier;

  var fieldObject = _objectSpread(_objectSpread({}, travelCompanion), {}, {
    // Here we create the actual id that will be in sync with number of fields we have in the form
    id: createId(parentIndex, 'A'),
    mainContactId: values.adults[0].mainContactId,
    birthdate: moment_default()(travelCompanion === null || travelCompanion === void 0 ? void 0 : travelCompanion.birthdate),
    customerId: '',
    attendeeIndex: parentIndex
  }, !isChild && {
    isMain: false
  });

  return setFieldValue(attendeeIdentifier, fieldObject);
};

var ContactInfoUtils_getHouseholdsAttendees = function getHouseholdsAttendees(householdsList) {
  var tempAttendees = [];
  householdsList.forEach(function (_ref34) {
    var adults = _ref34.adults,
        children = _ref34.children;
    var mainAdultsInCurrentHousehold = adults.filter(function (attendee) {
      return attendee === null || attendee === void 0 ? void 0 : attendee.isMain;
    }).length;

    var newAdults = Object(toConsumableArray["a" /* default */])(adults); // if the Main adult was selected else where; redefine a new main adult in the current household


    if (adults.length && mainAdultsInCurrentHousehold === 0) {
      newAdults = newAdults.map(function (adult, index) {
        return _objectSpread(_objectSpread({}, adult), {}, {
          isMain: index === 0
        });
      });
    }

    tempAttendees = [].concat(Object(toConsumableArray["a" /* default */])(tempAttendees), Object(toConsumableArray["a" /* default */])(newAdults), Object(toConsumableArray["a" /* default */])(children));
  });
  return tempAttendees.sort(function (a, b) {
    if (a.id < b.id) {
      return -1;
    }

    if (a.id > b.id) {
      return 1;
    }

    return 0;
  });
};



/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export redirectToOidc */
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");










function redirectToUri(router) {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation(), uri).toString();
      router.push(redirectUri);
    };
  };
}

function redirectToOidc(appContext) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  redirectToOidc: redirectToOidc,
  redirectToUri: redirectToUri
});

/***/ }),

/***/ "l/UU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_OPTION_VALIDITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ALREADY_EXISTS; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var BOOKING_ALREADY_EXISTS = 'BOOKING_ALREADY_EXISTS';

/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAIL_OPTIN; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* unused harmony export THEO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PASSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT_TYPES; });
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';
var PASSPORT = 'PASSPORT';
var IDCARD = 'IDCARD'; // right now we only manage these two document types

var DOCUMENT_TYPES = [PASSPORT, IDCARD];

/***/ })

}]);